import React from "react";
import SyncContactsModal from "../../../components/sync-contacts-modal";
import SyncInvoicesModal from "../../../components/sync-invoices-modal";

export default function AccountingSyncModals({
  showSyncModal,
  setShowSyncModal,
  showSyncInvoicesModal,
  setShowSyncInvoicesModal,
  showSyncBillsModal,
  setShowSyncBillsModal,
  syncTargetConnection,
  handleSyncSuccess
}) {
  const connectionId = syncTargetConnection ? syncTargetConnection.id : undefined;

  return (
    <>
      <SyncContactsModal
        show={showSyncModal}
        onHide={() => setShowSyncModal(false)}
        entityType="all"
        connectionId={connectionId}
        onSyncSuccess={handleSyncSuccess}
      />
      <SyncInvoicesModal
        show={showSyncInvoicesModal}
        onHide={() => setShowSyncInvoicesModal(false)}
        entityType="invoice"
        projectId={null}
        connectionId={connectionId}
        onSyncSuccess={handleSyncSuccess}
      />
      <SyncInvoicesModal
        show={showSyncBillsModal}
        onHide={() => setShowSyncBillsModal(false)}
        entityType="bill"
        projectId={null}
        connectionId={connectionId}
        onSyncSuccess={handleSyncSuccess}
      />
    </>
  );
}
